import React, { Suspense, useCallback, useContext, useEffect, useState } from 'react'
import { getEmployeesLeaves } from './Service/ReportService';
import ERROR_LIST from '../../../Services/Global-Services/Hadle_Errors';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TostMsg } from '../../../App';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { InputSwitch } from 'primereact/inputswitch';
import { EmployeeAwardsYears } from '../AwardList/Services/awardService';
import { Dropdown } from 'primereact/dropdown';
import moment from 'moment';

function LeaveApplied() {
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [Isloading, setIsloading] = useState(false);
    const toster = useContext(TostMsg);
    const [leaveApplyData, setLeaveApplyData] = useState([]);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
    const defaultImage = "/images/placeholder_profile.png";
    const [totalRecords, setTotalRecords] = useState(0);
    const [IsExEmployeeView, setIsExEmployeeView] = useState(false);
    const [selectApplyLeave, setSelectApplyLeave] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const selectedColumns = [
        "EmployeeName",
        "TotalLeavesTaken",
        "NextMonthApplied",
        "NextToNextMonthApplied",
        "JanLeaves",
        "FebLeaves",
        "MarLeaves",
        "AprLeaves",
        "MayLeaves",
        "JunLeaves",
        "JulLeaves",
        "AugLeaves",
        "SepLeaves",
        "OctLeaves",
        "NovLeaves",
        "DecLeaves",
    ];
    const [selectedYear, setSelectedYear] = useState(null);
    const [masterYear, setMasterYear] = useState(null);
    const [showCurrentMonthData, setShowCurrentMonthData] = useState(false);
    const currentMonthIndex = new Date().getMonth();
    const monthColumns = [
        { field: "JanLeaves", header: "Jan" },
        { field: "FebLeaves", header: "Feb" },
        { field: "MarLeaves", header: "Mar" },
        { field: "AprLeaves", header: "Apr" },
        { field: "MayLeaves", header: "May" },
        { field: "JunLeaves", header: "Jun" },
        { field: "JulLeaves", header: "Jul" },
        { field: "AugLeaves", header: "Aug" },
        { field: "SepLeaves", header: "Sep" },
        { field: "OctLeaves", header: "Oct" },
        { field: "NovLeaves", header: "Nov" },
        { field: "DecLeaves", header: "Dec" }
    ];

    const filteredMonths = monthColumns.filter((_, index) => {
        if (showCurrentMonthData) {
            return index = currentMonthIndex;
        } else {
            return index < currentMonthIndex;
        }
    });



    useEffect(() => {
        GetMasterSystemAlertList("Leave_Yearly_Taken", 1);
        getAwardYearList();
        // getEmployeesLeavesList();
    }, []);


    useEffect(() => {        
        getEmployeesLeavesList(currentPage, rowsPerPage);
    }, [selectedYear, currentPage, rowsPerPage, IsExEmployeeView, searchTerm]);

    function exportToCSV() {
        if (!selectApplyLeave || selectApplyLeave.length === 0) {
            toster.current.warn("Please select at least one employee");
            return;
        }
        const filteredData = selectApplyLeave.map((row) => {
            return selectedColumns.reduce((acc, col) => {
                acc[col] = row?.[col] ?? "";
                return acc;
            }, {});
        });
        const csv = Papa.unparse(filteredData);
        const blob = new Blob([csv], {
            type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, "LeaveAppliedReport.csv");
    }


    const GetMasterSystemAlertList = useCallback(async (message, type) => {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 0) {
                toster.current.success(msg?.Desc);
            } else if (msg?.Name == message && type == 1) {
                setMasterSystemAlertData(msg?.Desc);
            } else if (msg?.Name == message && type == 2) {
                // setMasterSystemAlertData(msg?.Desc);
            }
        });
    }, []);


    const onPageChange = (e) => {
        setCurrentPage(e.page);
        setRowsPerPage(e.rows);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // ✅ reset page
    };

    const handleInputChangeExEmployee = (e) => {
        setIsExEmployeeView(e.value);
    };

    const handleInputChangeYear = (e) => {
        setSelectedYear(e.value);
    };

    async function getAwardYearList() {
        const params = { OrgId: userDetails?.OrgId };
        try {
            const response = await EmployeeAwardsYears(params);

            const yearDetail = response?.Data?.reverse();
            setMasterYear(yearDetail);
            const currentYear = new Date().getFullYear().toString();
            const yearExists = yearDetail?.some(
                (item) => item.Year.toString() === currentYear
            );
            setSelectedYear(
                yearExists ? currentYear : yearDetail?.[0]?.Year
            );

        } catch (err) {
            toster.current.error(ERROR_LIST.AwardYear);
        }
    }


    async function getEmployeesLeavesList(page = 0, pageSize = rowsPerPage) {

        setIsloading(true);

        const params = {
            Year: selectedYear || moment().year(),
            ExEmployees: IsExEmployeeView ? 1 : 0,
            SearchTerm: searchTerm,
            PageNumber: page + 1,
            PageSize: pageSize
        };

        try {
            let response = await getEmployeesLeaves(params);

            setLeaveApplyData(response?.Data || []);
            setTotalRecords(response?.Data[0]?.TotalCount || 0);

        } catch (error) {
            toster.current.error(ERROR_LIST.DefaultError);
        }

        setIsloading(false);
    }

    const handleImageError = useCallback((event) => {
        event.target.src = defaultImage;
    }, []);


    const styleFullName = (rowData) => {
        return (
            <Link to={`/Profile/${rowData.GUID}`}>
                <div className="d-flex align-items-center">
                    <img
                        src={rowData?.ProfileImage || defaultImage}
                        onError={handleImageError}
                        className="rounded-lg me-2"
                        width="24"
                        alt=""
                    />{" "}
                    <span className="w-space-no">
                        {rowData?.EmployeeName} ({rowData?.EmpId})
                    </span>
                </div>
            </Link>
        );
    };

    return (
        <div>
            <div className="container-fluid position-relative">
                <div className="row team-directories g-3">
                    {/* HEADER */}
                    <div className="col-xl-12">
                        <div className="form-head d-flex flex-wrap align-items-center">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Leave Summary</h2>
                                {/* <p>{masterSystemAlertData}</p> */}
                                <p>Employee leave applied during the selected year.</p>
                            </div>
                            <div className="rightside-tabs">

                                <Link to="/Reports">
                                    <button className="back-newticket w-auto float-right">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-arrow-left-short"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                                            />
                                        </svg>{" "}
                                        Back
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-head row mb-3 justify-content-end">
                                    {/* <div className="me-auto">
                    <strong>All Employees ({leaveApplyData?.length})</strong>
                  </div> */}

                                    <div className="col-lg-8 col-md-12">
                                        <div className=" row gx-2 justify-content-end top-head-wfh-area">
                                             <div className="col-lg-2 d-flex align-items-center justify-content-end me-3">
                                                <input
                                                    type="checkbox"
                                                    checked={showCurrentMonthData}
                                                    onChange={() => setShowCurrentMonthData(!showCurrentMonthData)}
                                                />
                                                <label style={{ marginLeft: "3px", marginBottom: "0px", fontSize: "12px" }}>
                                                    Future Months
                                                </label>
                                            </div>
                                            <div
                                                className="select-futurepost-article col-lg-2"
                                                title="Ex-Employee View"
                                            >
                                                <label style={{ cursor: "pointer" }}>Ex-Employee</label>
                                                <div className="ml-auto d-flex">
                                                    <InputSwitch
                                                        checked={IsExEmployeeView}
                                                        onChange={(e) => handleInputChangeExEmployee(e)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="org-cate  col-lg-3">
                                                <Dropdown
                                                    name="Year"
                                                    value={selectedYear}
                                                    onChange={(e) => {
                                                        setSelectedYear(e.value);
                                                        handleInputChangeYear(e);
                                                    }}
                                                    options={masterYear}
                                                    optionLabel="Year"
                                                    optionValue="Year"
                                                    placeholder="Select a Year"
                                                    checkmark={true}
                                                    highlightOnSelect={false}
                                                />
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control col-lg-3 search-height"
                                                value={searchTerm}
                                                onChange={handleSearchChange}

                                                placeholder="Search"
                                            />

                                            <div className="org-cate  col-1 text-center">
                                                <button
                                                    className="export-btn"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Export"
                                                    onClick={() => exportToCSV()}
                                                >
                                                    <img
                                                        src="/images/excels.png"
                                                        alt="export"
                                                        style={{ width: "23px" }}
                                                    />
                                                </button></div>

                                           
                                        </div>
                                    </div>




                                </div>
                                <div className="table-responsive">
                                    <div className="table table-bordered Employeelist ">
                                        <DataTable
                                            value={leaveApplyData}
                                            lazy
                                            paginator
                                            rows={rowsPerPage}
                                            first={currentPage * rowsPerPage}
                                            totalRecords={totalRecords}
                                            onPage={onPageChange}
                                            loading={Isloading}
                                            dataKey="EmpId"
                                            selection={selectApplyLeave}
                                            onSelectionChange={(e) => setSelectApplyLeave(e.value)}
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        >
                                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                            <Column field="EmployeeName" body={styleFullName} header="Name" />
                                            <Column field="TotalLeavesTaken" header="Total YTD" />
                                            <Column field="NextMonthApplied" header="Apply Next Month" />
                                            <Column field="NextToNextMonthApplied" header="Apply Second Month" />
                                            {filteredMonths.map((col, index) => (
                                                <Column key={index} field={col.field} header={col.header} />
                                            ))}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {Isloading ? (
                <Suspense>
                    <ComponentLoader />
                </Suspense>
            ) : ("")}
        </div>
    )
}

export default LeaveApplied